/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VideoSceneData { 
    scene_id: string;
    label: VideoSceneData.LabelEnum;
    value: string;
}
export namespace VideoSceneData {
    export type LabelEnum = 'Fase Juego' | 'Sit. Numérica' | 'Defensa' | 'Ataque' | 'Resultado' | 'Asistencia' | 'Zona acción' | 'Lanzamiento' | 'Modelo Juego';
    export const LabelEnum = {
        FaseJuego: 'Fase Juego' as LabelEnum,
        SitNumrica: 'Sit. Numérica' as LabelEnum,
        Defensa: 'Defensa' as LabelEnum,
        Ataque: 'Ataque' as LabelEnum,
        Resultado: 'Resultado' as LabelEnum,
        Asistencia: 'Asistencia' as LabelEnum,
        ZonaAccin: 'Zona acción' as LabelEnum,
        Lanzamiento: 'Lanzamiento' as LabelEnum,
        ModeloJuego: 'Modelo Juego' as LabelEnum
    };
}


